/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Draggable } from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next'

import useStyles from './styles';
import DeleteButton from '../../common/buttons/DeleteButton';


const OptionInput = ({
  id, value, index, onDelete, onChange, multiple, editMode,
}) => {
  const { t } = useTranslation(['translation']);
  const classes = useStyles();
  const signClass = classnames(classes.inputSign, {
    [classes.multipleSign]: multiple,
    [classes.singleSign]: !multiple,
  });

  return (
    <Draggable
      draggableId={id}
      index={index}
    >
      {provided => (
        <div
          {...provided.draggableProps}
          ref={provided.innerRef}
          className={classes.option}
        >
          {!editMode && (
            <OptionHandler
              handlerContainer={classes.handlerContainer}
              handlerPoint={classes.handlerPoint}
              {...provided.dragHandleProps}
            />
          )}

          <input
            className={classnames(classes.input, classes.optionInput)}
            placeholder={t('CAMPAIGN.QUESTIONNAIRE.NEW_OPTION')}
            onChange={e => { onChange(id, e.target.value); }}
            value={value}
            disabled={editMode}
          />

          <div className={signClass} />

          {!editMode && <DeleteButton onClick={() => { onDelete(id); }} />}
        </div>
      )}
    </Draggable>
  );
};


OptionInput.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  multiple: PropTypes.bool.isRequired,
  editMode: PropTypes.bool.isRequired,
};

export default OptionInput;

const OptionHandler = ({ handlerContainer, handlerPoint, ...dragHandle }) => (
  <div className={handlerContainer} {...dragHandle}>
    <div className={handlerPoint} />
    <div className={handlerPoint} />
    <div className={handlerPoint} />
    <div className={handlerPoint} />
    <div className={handlerPoint} />
    <div className={handlerPoint} />
  </div>
);


OptionHandler.propTypes = {
  handlerPoint: PropTypes.string.isRequired,
  handlerContainer: PropTypes.string.isRequired,
};
